import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { Rate } from '../../../ui/rate';

export const LoanOverviewRBL = ({
    outstandingBalance,
    estimatedTimeToRepay,
    sweepFraction
}: {
    outstandingBalance: number;
    estimatedTimeToRepay: number;
    sweepFraction: number;
}) => {
    return (
        <div className="col-span-5 max-sm:col-span-full max-sm:mr-xl max-sm:pb-0">
            <div className="flex flex-row gap-xl max-sm:flex-col">
                {/* Outstanding Balance */}
                <div
                    className="mr-l flex flex-col justify-between border-secondary-80 pr-l max-sm:col-span-full min-l:border-r"
                    aria-label="outstanding-balance"
                >
                    <span>
                        <Text className="text-l font-med">
                            <FormattedMessage
                                id="_.dashboard.outstanding_balance"
                                defaultMessage="Outstanding Balance"
                            />
                        </Text>
                    </span>
                    <Text className="mt-xs text-2xl font-med">
                        <FormattedCurrency value={outstandingBalance!} />
                    </Text>
                </div>

                <div className="flex flex-row max-sm:flex-row-reverse min-l:gap-m min-xl:gap-5xl">
                    {/* Minimum Repayment Amount */}
                    <div
                        className="flex flex-1 flex-col justify-between"
                        aria-label="sweep-fraction"
                    >
                        <span>
                            <Text className="text-l font-med">
                                <FormattedMessage
                                    id="_.dashboard.loan_overview.rbl.revenue_sweep_title"
                                    defaultMessage="Sweep"
                                />
                            </Text>
                            <Text className="text-xs font-reg">
                                <FormattedMessage
                                    id="_.dashboard.loan_overview.rbl.sweep_fraction_description"
                                    defaultMessage="Percentage of sales per month"
                                />
                            </Text>
                        </span>
                        <Text className="mt-xs text-2xl font-med">
                            <Rate value={sweepFraction!} />
                        </Text>
                    </div>

                    {/* Repayment Period*/}
                    <div
                        className="flex flex-1 flex-col justify-between"
                        aria-label="repayment-period"
                    >
                        <span>
                            <Text className="text-l font-med">
                                <FormattedMessage
                                    id="_.dashboard.loan_overview.rbl.repayment_period_title"
                                    defaultMessage="Expected repayment period"
                                />
                            </Text>
                        </span>
                        <Text className="mt-xs text-2xl font-med">
                            <FormattedMessage
                                id="_.dashboard.loan_overview.rbl.repayment_period"
                                defaultMessage="{repaymentPeriod} months"
                                values={{
                                    repaymentPeriod: estimatedTimeToRepay
                                }}
                            />
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
};
